<template>
  <div class="home-hotsite">
    <v-container class="pa-0" fluid>
      <v-card class="my-3 px-6">
        <v-card-text>
          As edições de hotsite agora são na
          <a style="cursor: pointer; color: #1976d2; text-decoration: underline" @click.prevent="$router.push({ name: 'site-cadastramento' })">
            página de configuração de site de cadastramento </a
          >.
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'Hotsite',
}
</script>
